<template>
    <div class="search-input">
        <div class="input-container">
            <svg class="search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
                <path d="m21 21-4.35-4.35" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <input 
                type="text" 
                v-model="searchQuery" 
                @input="emitSearchUpdate" 
                placeholder="Search..."
                class="input" 
            />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'

defineExpose({
    reset
})

const emit = defineEmits(['search-update'])
const searchQuery = ref('')

function reset() {
    searchQuery.value = ''
    emitSearchUpdate()
}

function emitSearchUpdate() {
    emit('search-update', searchQuery.value)
}
</script>

<style scoped>
.search-input {
    width: 250px;
}

.input-container {
    position: relative;
    display: flex;
    align-items: center;
}

.search-icon {
    position: absolute;
    left: 16px;
    color: #9ca3af;
    pointer-events: none;
    transition: color 0.3s ease;
    z-index: 1;
}

.input {
    width: 100%;
    padding: 12px 16px 12px 48px;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    position: relative;
    overflow: hidden;
}

.input::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, rgba(102, 126, 234, 0.05) 0%, rgba(102, 126, 234, 0.02) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
}

.input:focus {
    outline: none;
    border-color: rgba(102, 126, 234, 0.3);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
    background: rgba(255, 255, 255, 0.98);
}

.input:focus + .search-icon,
.input-container:hover .search-icon {
    color: #667eea;
}

.input::placeholder {
    color: #9ca3af;
    font-weight: 400;
}

.input:focus::placeholder {
    color: #d1d5db;
}
</style>